import React from "react";

const experiences = [
  {
    company: "Cisco",
    role: "Software Engineer",
    duration: "Sept 2026 – Present",
    location: "Bangalore, India | (On-site)",
    filename: "cisco_systems.sh",
    command: "./cisco_systems.sh --active",
    bullets: [
      <>Analyze and debug <strong>large-scale enterprise codebases</strong> using code analysis and debugging practices to understand software behavior and identify issues.</>,
      <>Build systems and networking fundamentals through hands-on exposure to <strong>TCP/IP, OSI model, routing, switching, VLANs, ARP, MAC/IP addressing</strong>, and network troubleshooting.</>,
      <>Apply <strong>enterprise coding standards</strong> and version-control workflows while contributing to software development activities and maintaining code quality.</>,
      <>Collaborate in an <strong>Agile engineering environment</strong> on codebase analysis, debugging, and software development activities.</>
    ],
    skills: ["C", "C++", "Python", "TCP/IP", "Computer Networks", "Routing & Switching", "Debugging", "Git", "Agile"]
  },
  {
    company: "BlueVector AI",
    role: "Associate Cloud Engineer | Backend Developer",
    duration: "Dec 2025 – Jun 2026",
    location: "Denver, Colorado, United States (Remote) | (Contract)",
    filename: "bluevector_cloud.py",
    command: "python3 bluevector_cloud.py --status",
    bullets: [
      <>Collaborated within a matrix-based cross-functional team to discover, design, and demonstrate <strong>scalable RESTful API solutions</strong>, bridging the gap between technical requirements and tangible business outcomes.</>,
      <>Demonstrated analytical resilience by troubleshooting complex production cloud infrastructure; performed root-cause analysis to deconstruct "black box" software defects, <strong>improving system reliability by 60%</strong>.</>,
      <>Built <strong>Python automation and data-processing tools</strong> to optimize operational workflows, reducing manual engineering effort and accelerating product innovation.</>,
      <>Developed automated test cases for end-to-end testing using <strong>Playwright and TypeScript</strong>, integrating them into CI/CD pipelines via <strong>GitHub Actions</strong> for continuous execution.</>,
      <>Redesigned the <strong>Message Center architecture</strong> alongside peers by centralizing Email, SMS, and notification services, ensuring the software met strict maintainability standards.</>
    ],
    skills: ["Python", "GCP", "REST APIs", "Playwright", "TypeScript", "CI/CD", "GitHub Actions"]
  },
  {
    company: "Glopal Management and Services",
    role: "Software Developer",
    duration: "Sep 2025 – Dec 2025",
    location: "Kolkata, West Bengal (On-site) | (Contract)",
    filename: "glopal_erp.cpp",
    command: "./glopal_erp --deploy",
    bullets: [
      <>Engineered <strong>data pipelines and backend infrastructure</strong> for ERP systems, utilizing <strong>C++, PostgreSQL</strong>, and high-performance <strong>gRPC network APIs</strong> to solve complex data integration challenges.</>,
      <>Built UI/UX frameworks and <strong>reusable frontend components</strong> from Figma designs, maintaining a customer-first mindset to deliver key software enhancements.</>,
      <>Supported the broader engineering team in resolving <strong>10+ software defects in production systems</strong>, improving application performance by <strong>42%</strong>.</>,
      <>Created <strong>technical design documentation</strong> and contributed to user guides to translate technical complexity into clear narratives, facilitating knowledge sharing.</>
    ],
    skills: ["C++", "PostgreSQL", "gRPC", "ERP Systems", "UI/UX", "Figma"]
  },
  {
    company: "1 STOP (IIT DELHI)",
    role: "Backend Developer Intern",
    duration: "July 2023 – September 2023",
    location: "Virtual | (Internship)",
    filename: "ticket_booking.js",
    command: "node ticket_booking.js --start",
    bullets: [
      <>Contributed to the technical design and software development of a <strong>ticket booking management system</strong>, focusing on testability and development velocity.</>,
      <>Engineered backend features and optimized network requests to <strong>improve overall website responsiveness and performance by 76%</strong>.</>,
      <>Demonstrated high learning agility by rapidly absorbing best practices from senior team members while assisting in debugging software lifecycle issues.</>
    ],
    skills: ["Node.js", "Express.js", "REST APIs", "Network Optimization", "Testing", "Backend Architecture"]
  }
];

function Experience() {
  return (
    <section className="experienceSection" id="experience">
      <h1>{"/* Professional Experience */"}</h1>
      <div className="experience-container-relative">
        
        {/* Ambient Floating Tech Tags */}
        <div className="floating-tech-tag tag-flask">C++</div>
        <div className="floating-tech-tag tag-python">Python</div>
        <div className="floating-tech-tag tag-gcp">GCP</div>
        <div className="floating-tech-tag tag-jinja">TCP/IP</div>
        <div className="floating-tech-tag tag-html">PostgreSQL</div>
        <div className="floating-tech-tag tag-css">TypeScript</div>
        <div className="floating-tech-tag tag-js">REST APIs</div>

        <div className="experienceGrid">
          {experiences.map((exp, index) => (
            <div key={index} className="terminal-window experience-card">
              <div className="terminal-header">
                <span className="dot dot-red"></span>
                <span className="dot dot-yellow"></span>
                <span className="dot dot-green"></span>
                <span className="terminal-title">{exp.filename}</span>
              </div>
              <div className="terminal-body card-terminal-body">
                <p className="terminal-prompt">
                  <span className="prompt-symbol">~$</span> {exp.command}
                </p>
                <div className="experience-detail">
                  <h3>&gt; {exp.role}</h3>
                  <p className="experience-meta">{`// ${exp.company} (${exp.duration})`}</p>
                  <p className="experience-location">{`// ${exp.location}`}</p>
                  <ul className="terminal-bullet-points">
                    {exp.bullets.map((bullet, bIndex) => (
                      <li key={bIndex}>{bullet}</li>
                    ))}
                  </ul>
                  <div className="card-tech-tags-list">
                    {exp.skills.map((skill, sIndex) => (
                      <code key={sIndex}>{skill}</code>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Experience;